import * as ReviewRating from './ReviewRating';

export default ReviewRating;
